import type { TDocumentosPessoa } from '@/features/enviar-documentos/interfaces'
import { HttpService } from '@/infra'

export const TipoDocumentoEnum = {
  CNH: 'CNH',
  RG: 'RG',
  CPF: 'CPF',
  CertidaoDeNascimento: 'CertidaoDeNascimento',
  CertidaoDeCasamento: 'CertidaoDeCasamento',
  ComprovanteDeResidencia: 'ComprovanteDeResidencia',
  Procuracao: 'Procuracao',
  OutroDocumento: 'OutroDocumento',
  ComprovanteDePagamento: 'ComprovanteDePagamento',
  Checklist: 'Checklist',
  CartaoCNPJ: 'CartaoCNPJ',
  ContratoSocial: 'ContratoSocial',
  UltimaAlteracao: 'UltimaAlteracao',
  CertidaoJuntaComercial: 'CertidaoJuntaComercial',
  ComprovanteDeEnderecoDaEmpresa: 'ComprovanteDeEnderecoDaEmpresa',
} as const

export type TTipoDocumento = keyof typeof TipoDocumentoEnum

export interface TDocumentoLeadRepresado {
  tipo: TTipoDocumento
  dataEnvio: string
}

export interface TGetDocumentosLeadRepresadoResponse {
  documentos: TDocumentoLeadRepresado[]
}

export class GetDocumentosLeadRepresadoService extends HttpService {
  execute = async (clienteId: string) => {
    return this.http.get<TDocumentosPessoa>(`/api/v2/Cliente/leadRepresado/${clienteId}/documentos`)
  }
}
